"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tckn = exports.strictTckn = void 0;
var _validateMessages = require("./validateMessages");
// import { LocaleReceiver } from '../locales/LocaleContext';

var validationMessages = (0, _validateMessages.messages)().custom;
var tckn = exports.tckn = function tckn(rule, value, callback, validation) {
  var isStrict = true;
  validation.forEach(function (item) {
    if (item.strict) {
      isStrict = strictTckn(rule, value, callback);
    }
  });
  var stringValue = String(value);
  var regex = new RegExp('^[1-9]{1}[0-9]{10}$');
  var result = regex.test(stringValue);
  if (value && (!result || !isStrict)) {
    callback([new Error(validationMessages.tckn)]);
  }
  callback();
};
var strictTckn = exports.strictTckn = function strictTckn(rule, value, callback) {
  var stringValue = String(value);
  var odds = 0,
    evens = 0,
    result = 0,
    firstTenDigitSum = 0;

  // 11 sayıdan oluşmalı ve ilk hane 0 olmamalı
  if (stringValue.length != 11 || stringValue[0] == 0) return false;

  // 1, 3, 5, 7 ve 9. hanelerinin toplamının 7 katı ile 2, 4, 6 ve 8. hanelerin toplamının çıkarılması ile elde edilen sonucun 10’a bölümünden kalan 10. haneye eşit olmalı
  odds = parseInt(stringValue[0]) + parseInt(stringValue[2]) + parseInt(stringValue[4]) + parseInt(stringValue[6]) + parseInt(stringValue[8]);
  evens = parseInt(stringValue[1]) + parseInt(stringValue[3]) + parseInt(stringValue[5]) + parseInt(stringValue[7]);
  result = odds * 7 - evens;
  if (result % 10 != stringValue[9]) return false;

  // İlk 10 hanenin toplamının 10’a bölümünden kalan 11. haneye eşit olmalı
  stringValue.split(' ').forEach(function (digit) {
    firstTenDigitSum += digit;
  });
  if (firstTenDigitSum % 10 != stringValue[10]) return false;

  // TCKN yukarıdaki kurallara uysa bile hatalı kabul edilen listede bulunmamalı
  if (invalidTCKNList.includes(stringValue)) return false;
  return true;
};
var invalidTCKNList = ['11111111110', '22222222220', '33333333330', '44444444440', '55555555550', '66666666660', '77777777770', '88888888880', '99999999990'];